/* eslint-disable */
import ggAuth from 'ggApp/modules/auth';
import ggTranslator from 'ggApp/modules/translator';
import ggStore from 'ggApp/modules/store';
import { translate, } from 'ggApp/modules/translator/selectors';

import React, { Component, } from 'react';
import { connect, } from 'react-redux';
import { createStructuredSelector, } from 'reselect';
import { Helmet, } from "react-helmet";

@connect(
  createStructuredSelector({
    user: ggAuth.selectors.user,
    translations: ggTranslator.selectors.keys,
    storeActive: ggStore.selectors.storeActive,
  })
)
export default class PaymentWrap extends Component {

  componentWillMount() {
    const
      { user, } = this.props;

    if(!user.id) {
      window.location = window.location.origin;
    }
  }

  render() {
    const
      {
        children,
        translations,
        storeActive,
      } = this.props;
    const title = translate(translations, storeActive.activeLanguage, 'PAYMENT_META_TITLE');

    return (
      <div>
        <Helmet>
          <title>{title}</title>
        </Helmet>

        {children}
      </div>
    );
  }

}
